const imageData = {
  0: ["/User-80.png", 20],
  1: ["/user2.png", 40],
  2: ["/user3.png", 30],
  3: ["/user4.png", 49],
  4: ["/user5.png", 20],
};

export default imageData;
